import {Employer} from "./employer";

export class OrderDraftEmployerFilter {
  employer: Employer;
}
